import {mediaServiceIsAuthenticated} from '@netx/core-share-media-service/enablers';
import {currentUserMeetsUserLevel, UserLevel} from '@netx/core-user-next/utils';
import {type IAsset} from '../schema';

export const canPublishAsset = (asset?: IAsset, mediaServiceName = '') =>
	asset?.fileFormatFamily.includes('video') === true &&
	currentUserMeetsUserLevel(UserLevel.CONSUMER) &&
	mediaServiceIsAuthenticated(mediaServiceName);
